export default __webpack_public_path__ + "static/media/paper.fa6c6a3d.png";